// Synthetic sensory fixtures for the Assess phase. Numbers shaped to look
// right for a Round-2 review — not real data.

export const HEDONIC_DISTRIBUTION = [2, 3, 4, 8, 14, 22, 38, 41, 16];

export type JarAttr = {
  name: string;
  dist: [number, number, number, number, number];
  penalty: number;
};

export const JAR_ATTRIBUTES: JarAttr[] = [
  { name: "Vanilla intensity", dist: [3, 28, 84, 26, 7], penalty: -0.41 },
  { name: "Sweetness", dist: [4, 12, 102, 24, 6], penalty: -0.18 },
  { name: "Creaminess", dist: [2, 8, 118, 16, 4], penalty: -0.08 },
  { name: "Aftertaste length", dist: [9, 31, 78, 22, 8], penalty: -0.32 },
];

export type PiBox = {
  lbl: string;
  pct: number;
  tone: string;
};

export const PI_BOXES: PiBox[] = [
  { lbl: "definitely", pct: 24, tone: "var(--brand-green)" },
  { lbl: "probably", pct: 34, tone: "var(--accent)" },
  { lbl: "might/might not", pct: 22, tone: "var(--ink-3)" },
  { lbl: "probably not", pct: 14, tone: "var(--brand-amber)" },
  { lbl: "definitely not", pct: 6, tone: "#c25a4a" },
];

export const QDA_AXES = [
  "VANILLIN",
  "SWEET-AROMATIC",
  "CREAMY",
  "CARAMELIZED",
  "BUTTERY",
  "PHENOLIC",
  "HAY/DRIED",
  "BITTER",
  "ASTRINGENT",
];

export const QDA_TARGET = [11.2, 9.8, 9.4, 7.0, 5.6, 1.4, 3.2, 1.5, 1.0];
export const QDA_PANEL = [10.4, 9.2, 8.8, 7.6, 5.0, 2.1, 3.9, 2.0, 1.8];
export const QDA_PREDICTED = [10.8, 9.5, 9.1, 7.2, 5.4, 1.8, 3.4, 1.7, 1.2];
export const QDA_PVALUES = [0.41, 0.62, 0.71, 0.18, 0.34, 0.04, 0.21, 0.03, 0.08];

export type Panelist = {
  name: string;
  role: string;
  d: number;
  c: number;
  a: number;
  status: "ok" | "drift";
};

export const PANELISTS: Panelist[] = [
  { name: "M. Okafor",    role: "Lead",     d: 0.92, c: 0.96, a: 0.88, status: "ok" },
  { name: "L. Henriksen", role: "Beverage", d: 0.84, c: 0.91, a: 0.83, status: "ok" },
  { name: "R. Tanaka",    role: "Sensory",  d: 0.88, c: 0.94, a: 0.85, status: "ok" },
  { name: "S. Costa",     role: "QC",       d: 0.79, c: 0.86, a: 0.78, status: "ok" },
  { name: "J. Park",      role: "Dairy",    d: 0.71, c: 0.74, a: 0.69, status: "drift" },
  { name: "F. Adeyemi",   role: "Consumer", d: 0.94, c: 0.92, a: 0.90, status: "ok" },
];

export type QcCheckStatus = "pass" | "warn" | "pending";

export type QcCheck = {
  name: string;
  status: QcCheckStatus;
};

export const QC_CHECKS: QcCheck[] = [
  { name: "Allergen panel · 14 markers",    status: "pass" },
  { name: "FDA 21 CFR 172 lookup",          status: "pass" },
  { name: "EU 1334/2008 cross-check",       status: "pass" },
  { name: "FEMA GRAS · linked submissions", status: "pass" },
  { name: "Stability · 30 d @ 40 °C",       status: "pending" },
  { name: "GC-MS ID confirmation",          status: "warn" },
];

export type DfcRow = {
  name: string;
  v: number;
  blind: number;
  bold?: boolean;
};

export const DFC_DEFAULT_ROWS: DfcRow[] = [
  { name: "Aroma",       v: 3.1, blind: 0.4 },
  { name: "Flavor",      v: 2.4, blind: 0.5 },
  { name: "Mouthfeel",   v: 1.2, blind: 0.3 },
  { name: "Aftertaste",  v: 3.0, blind: 0.4 },
  { name: "Overall",     v: 2.6, blind: 0.4, bold: true },
];

export const TEMPORAL_METRICS = [
  { n: "Sweet",   tp: "4.0 s",  pk: "55%", dur: "12 s", auc: 4.8, d: -2  },
  { n: "Vanilla", tp: "7.0 s",  pk: "42%", dur: "16 s", auc: 5.2, d: 8   },
  { n: "Creamy",  tp: "10.0 s", pk: "28%", dur: "14 s", auc: 3.1, d: 4   },
  { n: "Bitter",  tp: "12.0 s", pk: "18%", dur: "10 s", auc: 1.4, d: -38 },
  { n: "Cool",    tp: "14.0 s", pk: "12%", dur: "8 s",  auc: 0.7, d: 0   },
];
